export const LandingPageHeroContentENUSTranslations = {
  landingPageHeroParagraph:
    'Improve your business decision-making through data, AI and integrated planning.',
  landingPageHeroImgAlt:
    'Image of some product features such as chat 4i, projects, indicators, and charts',
};
